export function formatPrice(cents: number | null) {
  return cents === null ? '' : `$${(cents / 100).toFixed(2)}`;
}
